import { useCallback, useEffect, useState } from 'react';

export const useIsScrollable = (ref) => {
    const updateIsScrollable = useCallback(() => {
        const { current: scrollableWrapper } = ref;

        if (!scrollableWrapper) {
            return;
        }

        setIsScrollable(
            scrollableWrapper.scrollWidth > scrollableWrapper.clientWidth
        );
    }, [ref]);

    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        updateIsScrollable();

        window.addEventListener('resize', updateIsScrollable);

        return () => window.removeEventListener('resize', updateIsScrollable);
    }, [ref]);

    return isScrollable;
};
